"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputController = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _emittery = _interopRequireDefault(require("emittery"));
var _state = require("../state");
var _util = require("@blockwell/util");
var _CachedContractsLoader = require("./CachedContractsLoader");
var _ApprovalHandler = require("./ApprovalHandler");
/**
 * Central controller for managing dumbapp inputs for submission.
 */

class InputController extends _emittery.default {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "values", new _state.ExecutionStateValueProvider());
    (0, _defineProperty2.default)(this, "execution", new _state.ExecutionController());
    (0, _defineProperty2.default)(this, "resolver", new _state.ExecutionArgumentResolver());
    (0, _defineProperty2.default)(this, "contractsLoader", new _CachedContractsLoader.CachedContractsLoader());
    (0, _defineProperty2.default)(this, "approval", new _ApprovalHandler.ApprovalHandler());
    (0, _defineProperty2.default)(this, "lastResolveResult", void 0);
    (0, _defineProperty2.default)(this, "dumbapp", null);
    (0, _defineProperty2.default)(this, "account", null);
    (0, _defineProperty2.default)(this, "hidden", true);
    (0, _defineProperty2.default)(this, "doResolve", (0, _util.debounce)(values => {
      this.execution.resolve(values.state).then(async res => {
        if (res.success === true) {
          this.lastResolveResult = {
            success: true,
            arguments: res.data.arguments,
            approve: res.data.state.approve,
            state: res.data.state,
            values
          };
          this.emit("resolve", this.lastResolveResult);
        } else {
          this.lastResolveResult = res;
          this.emit("resolve", res);
        }
      });
    }));
    this.execution.addHandler("InputController", "prepareRequest", simulation => {
      let created = new Date().toISOString();
      if (!this.dumbapp) {
        return {
          success: false,
          code: "no_dumbapp",
          message: "No dumbapp loaded, probably due to misconfiguration."
        };
      }
      return {
        success: true,
        data: {
          simulation,
          dumbapp: this.dumbapp,
          created,
          data: [],
          extras: {}
        }
      };
    });
    this.execution.addHandler("ExecutionArgumentResolver", "resolve", this.resolver.handler);
    this.execution.addHandler("InputController", "loadContracts", this.contractsLoader.handler);
    this.execution.addHandler("ApprovalHandler", "preExecute", this.approval.handler);
  }
  get lastResolve() {
    return this.lastResolveResult;
  }
  update(dumbapp, account) {
    this.dumbapp = dumbapp;
    this.account = account;
    this.hidden = false;
  }
  setApi(api) {
    this.contractsLoader.setApi(api);
    this.approval.setApi(api);
  }
  setHidden(hidden) {
    this.hidden = hidden;
    this.trigger();
  }
  placeholderText() {
    return "Enter a value in the form";
  }
  trigger() {
    if (this.dumbapp && !this.hidden) {
      this.execution.simulate().then(res => {
        if (res) {
          var _res$wallet;
          this.values.state = res;
          this.account = (_res$wallet = res.wallet) === null || _res$wallet === void 0 ? void 0 : _res$wallet.account;
          this.emit("change", this.values);
          this.doResolve(this.values);
        }
      });
    }
  }
  resolve() {
    if (this.values.state) {
      this.doResolve(this.values);
    }
  }
}
exports.InputController = InputController;
//# sourceMappingURL=InputController.js.map